import scared from "../assets/images/Bunny-scared.gif"
import { Link, useNavigate, useParams } from "react-router-dom";
import { a } from "../services/axiosInstance";
import { HOME } from "../services/consts";

function Delete() {

    const {id} = useParams();
    const navigate = useNavigate();

    async function handleDelete() {
        try {
            await a.delete(`items/delete/${id}/`)
            navigate(HOME);
        } catch (e) {
            console.log(e);
        }
    }

    return(
        <div className="block is-dark">
            <div className="container is-dark">
                <p className="desc">Are you sure you want to delete it?</p>
                <div className="background">
                    <span className="triangle"></span>
                    <div className="circle"></div>
                    <img className="scared" src={scared} alt="bunny" />
                </div>
                <div className="chose">
                    <Link to={HOME} className="no">CANCEL</Link>
                    <button onClick={handleDelete} className="yes">DELETE</button>
                </div>
            </div>
        </div>
    );
}

export default Delete;